import { render } from "./Button.vue?vue&type=template&id=2044fc41&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=2044fc41&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2044fc41"]])

export default __exports__